<div>
    <div mat-dialog-title>
        <div class="col-12">
            <span class="col-12 d-flex">
                <span class="ml-auto">Drive Connect</span>
                <span class="float-right ml-auto drive-connect-close-icon cursor-pointer fa fa-close" (click)="close();"></span>
            </span>
        </div>

    </div>
    <mat-dialog-content class="mat-typography">
        <span class="row col-12 p-0 m-0">
            <div class="col-12">A combination of onboard and cloud computing capabilities allows for seamless control. * Using your normal speaking
                voice, simply saying "Hey {{appName}}" enables you to access integrated Google* point-of-interest for faster
                results, more accurate directions and alternate routes. You can also connect with a live agent to have points
                of interest sent directly to your {{appName}} Beyond navigation* accessing media, phone and commonly used
                vehicle features like climate control are easier than ever. </div>

        </span>
    </mat-dialog-content>
</div>